module.exports = __webpack_public_path__ + "static/candriam-academy-5a6af034400e83f684c48e06ec2cfc67.svg";